import React from "react";

var MapSearchIcon = function MapSearchIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M15 6a8.98 8.98 0 0 1 7 3.349V2.75L14.667 0l-8.25 2.75L0 0v17.417l6.417 2.75 1-.333A8.947 8.947 0 0 1 6 15a9 9 0 0 1 9-9zm8.561 15.439l-2.667-2.667A6.998 6.998 0 0 0 10.05 10.05a6.999 6.999 0 0 0 0 9.899A6.974 6.974 0 0 0 15 22a6.984 6.984 0 0 0 3.772-1.106l2.667 2.667c.293.293.677.439 1.061.439s.768-.146 1.061-.439a1.502 1.502 0 0 0 0-2.122zm-5.732-3.611C17.073 18.584 16.068 19 15 19s-2.073-.416-2.828-1.172a4.004 4.004 0 0 1 0-5.657C12.927 11.416 13.932 11 15 11s2.073.416 2.828 1.172a4.004 4.004 0 0 1 .001 5.656z"
  }));
};

MapSearchIcon.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
MapSearchIcon.defaultProps.solid = true;
export default MapSearchIcon;